import { render, staticRenderFns } from "./SpeceficParent.vue?vue&type=template&id=4f5abdca&scoped=true"
import script from "./SpeceficParent.vue?vue&type=script&lang=js"
export * from "./SpeceficParent.vue?vue&type=script&lang=js"
import style0 from "./SpeceficParent.vue?vue&type=style&index=0&id=4f5abdca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5abdca",
  null
  
)

export default component.exports